export const loadingStyles: React.CSSProperties = {
  position: 'fixed',
  top: '45%',
  left: '0%',
  width: '100%',
  fontSize: 10,
};
